<canvas #waveCanvas></canvas>

<div class="banner-content">
  <img src="/images/logo_ucc_blanco.png" alt="Logo UCC" class="banner-logo" />
</div>
